import React, { createRef, Component } from "react";
import {
  Map,
  WMSTileLayer,
  ScaleControl,
  Marker,
  GeoJSON,
  ZoomControl,
} from "react-leaflet";
import { Button, Popup, Menu } from "semantic-ui-react";
import L from "leaflet";
import Control from "react-leaflet-control";
import axios from 'axios';
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExpand,
  faWindowClose,
  faChartBar,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList,
} from "@fortawesome/free-solid-svg-icons";
import MouseControl from "../../MousePosition";
import domain from "../../domain";

import colors from "../../colors";
import urls from "../../urls";
// import * as helpers from '../../helpers'
import { OffCanvas, OffCanvasMenu } from "react-offcanvas";
import { FadeLoader } from "react-spinners";
import ReactHTMLParser from "react-html-parser";
import DateSlider from "./DateSlider";
import moment from "moment";

library.add(
  faWindowClose,
  faChartBar,
  faExpand,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList
);

const crs = L.CRS.EPSG4326;
const style = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};
const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 1,
      minZoom: 7,
      maxZoom: 15,
      // viewport: {
      //   zoom: 8,
      //   center: [25.12539, 80.00164],
      // },
      zoom: 7,
      center: [25.12539, 80.00164],
      latlng: { lat: null, lng: null },
      pointInfo: null,
      wms_url: `${domain.Geoserver}/nhp_irrigation/wms`,
      // wms_url_default:`${domain.Geoserver}geoserver/surface-runoff-index-30-day-cumulative/wms`,
      legend_overlay: {},
      legend_title: null,
      legendVisible: true,
      visibleRight: false,
      isExpand: false,
      showInfo: false,
      layerloading: false,
      legend_array_overlay: {},
      
      layers: urls.map_layer,
      url: urls.bhuvan_map,

      // layers: urls.s_layer,
      // url: urls.satellite,

      // layers: "nhp_irrigation%:India Command Area",
      // // url='http://192.168.192.103:8080/geoserver/cite/wms'
      // url: `${domain.Geoserver}/nhp_irrigation/wms`,
      // layers:'india3',
      // url:'https://bhuvan-vec1.nrsc.gov.in/bhuvan/gwc/service/wms',

      baseLayers: false,
      baselayerselected: "Map",
      isMenuOpened: true,

      
    };
    this.RangeRef = React.createRef();

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e){

    if(this.props.basinoverlays[3].isChecked) {
      this.props.handleMapClick(e.latlng);
    }    

    console.log('CAD MP', e.latlng);
    console.log('basin Over', this.props.basinoverlays);
    console.log('arra Over', this.props.arraycheck);
 
  }

  mapRef = createRef();
  tileRef = createRef();
  loading = (e) => {
    this.setState({
      layerloading: true,
    });
    // console.log(e)
  };
  load = (e) => {
    this.setState({
      layerloading: false,
    });
  };

  handleSwipeChange = (value) => {
    //  console.log(event.target.value)
    const map = this.mapRef.current.leafletElement;

    this.clip(value);
    map.on("move", this.clip);

    // this.setState({
    //         value:event.target.value
    //     })
  };

  resetZoom = () => {
    const leafletMap = this.mapRef.current.leafletElement;
    leafletMap.setZoom(this.state.zoom);
    leafletMap.panTo(new L.LatLng(16.68539, 76.85164));
  };

  displayLegend = () => {
    this.setState({ legendVisible: !this.state.legendVisible });
  };

  showInfo = () => {
    this.setState({ showInfo: !this.state.showInfo });
  };

  onMouseOver = (e) => {
    this.setState({
      latlng: e.latlng,
      // latlng:{lat: L.Projection.LonLat.project(e.latlng).y, lng:L.Projection.LonLat.project(e.latlng).x}
      // showInfo:true,
    });
    console.log("irriiii",e,e.latlng);
    // this.props.setLatLng({lat: L.Projection.LonLat.project(e.latlng).y, lng:L.Projection.LonLat.project(e.latlng).x})
    this.props.setLatLng(e.latlng);

    this.props.makeChartDataAvailableDays();
    if (this.props.selected !== null) {
      this.props.handleVisibleGraphPanelOnMapClick();
    }
  };

  onViewportChanged = (viewport) => {
    console.log(viewport);
    this.props.setViewport(viewport);
    // setViewport(viewport)
  };

  componentDidUpdate(prevProps, PrevState) {
    console.log(this.props.selectedLayer);
    
    // if(this.props.selected!==prevProps.selected){
    if (this.props.selectedLayer !== prevProps.selectedLayer) {
      
      let layer =
        this.props.selected !== null
          ? this.props.selected.toLowerCase().split(" ").join("-") +
          ":" +
          this.props.selectedLayer[this.props.selected]
          : null;

      let wms_url =
        this.props.selected !== null
          ? `${domain.Geoserver}/nhp_${this.props.selected
            .toLowerCase()
            .split(" ")
            .join("-")}/wms` : null
      // let wms_url =
      //   this.props.selected !== null
      //     ? `${domain.Geoserver}/nhp_${this.props.selected
      //         .toLowerCase()
      //         .split(" ")
      //         .join("-")}/wms`
      //     : this.props.wms_url_base_layers;

      let season = this.props.selectedLayer[this.props.selected].split("_")[6];
      const colors_range = ["#00FF00", "#FF0000", "#0000FF"];
      const colors_range_rabi = ["#00FF00", "#FF0000", "#0000FF"];
      const grades = ["  Khariff ID", " Kharif Paddy", " Cotton & Chillies"];
      const grades_rabi = ["  Rabi ID", " Rabi Paddy"];
      const cwr_grades = [
        " 0 ",
        "0.1",
        "7.4",
        "19.8",
        "32.0",
        "44 ",
        ">57",
      ];
      const cwr_color_range = [
        "#FFFFFF",
        "#ffc0cb",
        "#7aab00",
        "#FFFF00",
        "#ff9900",
        "#ff2200",
        "#0000ff",
      ];

      let img_cwr = (
        <div
          style={{
            textAlign: "center",
            fontSize: "12px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="cwr_color_scale"></div>
          <div style={{ float: "left", paddingLeft: "5px", marginTop: "0px" }}>
            0<br />
            0.1
            <br />
            7.4
            <br />
            19.8
            <br />
            32.0
            <br />
            44
            <br />
            >57
          </div>
        </div>
      );

      let img_crop_map = grades.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i key={key} style={{ background: `${colors_range[key]}` }}></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      let img_crop_map_rabi = grades_rabi.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i
              key={key}
              style={{ background: `${colors_range_rabi[key]}` }}
            ></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      // let img_cwr = cwr_grades.map((value, key) => {
      //   // console.log(index)
      //   return (
      //     <React.Fragment>
      //       <i key={key} style={{ background: `${cwr_color_range[key]}` }}></i>{" "}
      //       {value} <br />{" "}
      //     </React.Fragment>
      //   );
      // });

      if (this.props.selected === "Crop Map" && season === "kharif")
        this.props.setLegend(img_crop_map);
      else if (this.props.selected === "Crop Map" && season === "rabi")
        this.props.setLegend(img_crop_map_rabi);
      else if (
        this.props.selected === "Crop Water Demand-Crop Water Requirement"
      ) {
        this.getLegendGraphic(wms_url, layer).then((legend) => {
          console.log(legend)
          this.props.setLegend(legend);
        })
      }
      else if (
        this.props.selected === "Crop Water Demand-Irrigation Water Requirement"
      ) {
        this.getLegendGraphic(wms_url, layer).then((legend) => {
          this.props.setLegend(legend);
        })
      }
      else if (this.props.selected === "Satellite Imagery-Optical")
        this.props.setLegend(null);
      else if (this.props.selected === "Satellite Imagery-Microwave")
        this.props.setLegend(null);

      // this.getLegendGraphic(wms_url, layer).then((legend)=>{
      //     console.log(legend)
      //     this.props.setLegend(legend)
      //     this.setState({
      //         legend:legend
      //     })
      // })
      // this.props.makeChartDataAvailableDays()

      
    }

    
    
    



    if (
      this.props.swipevalue !== prevProps.swipevalue &&
      this.props.basinoverlays !== null
    ) {
      this.handleSwipeChange(this.props.swipevalue);
    }
    if (this.props.basinoverlays !== prevProps.basinoverlays) {
    }
    if (this.props.visibleLeft === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
    if (this.props.visibleGraphPanel === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
    // setTimeout(function () {
    //   const leafletMap = this.mapRef.current.leafletElement;
    //   leafletMap.invalidateSize();
    // }, 0);
  }

  async getLegendGraphic(wms_url, layer) {
    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 40;
    let height = 20;

    let img_src = `${wms_url}?request=${request}&layer=${layer}&format=${format}&width=${width}&height=${height}&legend_options=dpi:100`;

    return img_src;
  }

  getLegendGraphicIrrigation(workspace, layer) {
    let wms_url = `${domain.Geoserver}/${workspace}/wms`;
    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 20;
    let height = 20;

    let img_src = `${wms_url}?request=${request}&version=1.0.0&strict=false&style=${layer}&format=${format}&width=${width}&height=${height}`;

    return img_src;
  }

  getLegendGraphicOverlay(workspace, lay) {
    let wms_url = `${domain.Geoserver}/${workspace}/wms`;
    let layer = workspace + ':' + lay; 
    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 20;
    let height = 20;

    let img_src = `${wms_url}?request=${request}&version=1.0.0&strict=false&layer=${layer}&format=${format}&width=${width}&height=${height}`;

    return img_src;
  }

  handleAnimationChangeRight = () => {
    this.setState({
      visibleRight: !this.state.visibleRight,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };
  handleExpand = () => {
    this.setState({
      isExpand: !this.state.isExpand,
    });
  };

  handleDialogClose = () => {
    this.props.handleDialogCloseD();
  };

  

  highlightState = (feature, layer) => {
    layer.setStyle({
      weight: 3,
      color: "#828faf",
      fillOpacity: 0,
    });

    // layer.on({
    //     click: (event) => {

    //         layer.setStyle({
    //             weight: 3,
    //             color: '#c493aa',
    //             fillOpacity: 0.2
    //         });

    //     }
    // });
  };
  getLegendGraphic_basic = (e) => {
    let wms_url = this.state.wms_url;
    let title;
    console.log(e.name);
    let legend_array_overlay = { ...this.state.legend_array_overlay };
    let layer = "nhp_irrigation:" + e.name.toLowerCase().split(" ").join("_");
    if (e.name === "canal network") {
      title = "Canal Network";
    } else if (e.name === "LULC") {
      title = "Land Use and Land Cover";
    } else if (e.name === "Soil Map") {
      title = "Soil Map";
    }
    console.log(wms_url);

    this.getLegendGraphic(wms_url, layer).then((legend) => {
      //  this.props.setLegend(legend)
      legend_array_overlay[e.name] = legend;
      console.log(legend_array_overlay);
      this.setState({
        legend_array_overlay: legend_array_overlay,
        legend_overlay: legend,
        legend_title: title,
      });
    });
  };
  getLegendGraphic_remove = (e) => {
    // let wms_url =this.state.wms_url
    // console.log(e.name)
    // let layer='nhp_irrigation:'+e.name.toLowerCase().split(' ').join('_')
    let name = e.name;
    let legend_array_overlay = { ...this.state.legend_array_overlay };
    console.log(legend_array_overlay);
    delete legend_array_overlay[name];
    console.log(legend_array_overlay);

    this.setState({
      legend_array_overlay: legend_array_overlay,
      legend_overlay: null,
    });
  };
  highlightStudyArea = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;
    layer.on({
      mouseover: (e) => {
        // highlightCounty(e);
        layer.bringToBack();
      },
      mouseout: (e) => {
        //   this.resetCountyHighlight(e);
        layer.bringToBack();
      },
    });
    layer.bringToBack();
    layer.setStyle({
      weight: 2,
      color: "blue",
      // color: "#00FF00",
      fillOpacity: 0,
      fill: false,
    });

    console.log('Bounds', layer.getBounds());
   /// map.fitBounds(layer.getBounds());
   map.flyToBounds(layer.getBounds(), {
    animate: true, // Enables animation
    duration: 1,   // Duration in seconds (adjust as needed)
    easeLinearity: 0.25, 
     //maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
  //  padding: [50, 50] // Adds some padding around the bounds
  });

    // layer.on({
    //     click: (event) => {

    //         layer.setStyle({
    //             weight: 3,
    //             color: '#c493aa',
    //             fillOpacity: 0.2
    //         });

    //     }
    // });
  };

  clip = (value) => {
    var last;
    const map = this.mapRef.current.leafletElement;
    var layers = [];
    let overlay = this.props.basinoverlays;

    console.log('Test 123 over', overlay);
    let test = [];
    overlay.forEach((overlay) => {
      if (overlay.isChecked) {
        test.push(overlay.value);
      }
    });
    console.log(test);
    map.eachLayer(function (layer) {
      // console.log(layer.options.layers)
      if (layer instanceof L.TileLayer) {
        console.log(layer.wmsParams.layers);
        for (var i = 0; i < test.length; i++) {
          if (layer.wmsParams.layers === "nhp_irrigation:" + test[i])
            layers.push(layer);
        }
      }
    });
    console.log(layers);
    if (layers.length > 0) {
      last = layers[layers.length - 1];

      var nw = map.containerPointToLayerPoint([0, 0]),
        se = map.containerPointToLayerPoint(map.getSize()),
        clipX = nw.x + (se.x - nw.x) * value;
      last.getContainer().style.clip =
        "rect(" + [nw.y, clipX, se.y, nw.x].join("px,") + "px)";
      for (var i = 0; i < layers.length - 1; i++) {
        // var nw = map.containerPointToLayerPoint([0, 0]),
        //   se = map.containerPointToLayerPoint(map.getSize()),
        clipX = nw.x + (se.x - nw.x) * 1;
        layers[i].getContainer().style.clip =
          "rect(" + [nw.y, clipX, se.y, nw.x].join("px,") + "px)";
      }
    }
  };

  displayBaseLayers = () => {
    console.log("base layers");
    this.setState({
      baseLayers: !this.state.baseLayers,
    });
  };

  // changeBaseLayer = (event) => {
  //   let layers, url;
  //   //  this.findActiveLayers()
  //   console.log(event.target);
  //   if (event.target.value === "Map") {
  //     url = urls.bhuvan_map;
  //     layers = urls.map_layer;
  //   } else if (event.target.value === "Satellite") {
  //     layers = urls.s_layer;
  //     url = urls.satellite;
  //   } else if (event.target.value === "Command Area") {
  //     layers = "nhp_irrigation%:India Command Area";
  //     url = `${domain.Geoserver}/nhp_irrigation/wms`;
  //   }

  //   this.setState({
  //     baselayerselected: event.target.value,
  //     url: url,
  //     layers: layers,
  //   });
  // };

  changeBaseLayer = (event) => {
    this.props.changeBaseLayer(event.target.value);
  };

  render() {
    delete L.Icon.Default.prototype._getIconUrl;
    let test;
    let legend_bar;
    console.log(this.props.selected);

    console.log("console.log",this.props.distributary_details);

    // let hist_layer, hist_url;

    // if (this.props.selected === 'Historical Season-Crop Map Historic') {
    //   hist_url = `${domain.Geoserver}/nhp_crop-water-demand-irrigation-total-command/wms`;
    //   hist_layer = `${this.props.hist_cropseason}`;
    // } else if (this.props.selected === 'Historical Season-Irrigation Requirement') {
    //   hist_url = `${domain.Geoserver}/nhp_crop-water-demand-irrigation-total-command/wms`;
    //   hist_layer = `${this.props.hist_cropseason}`;
    // } else if (this.props.selected === 'Historical Season-Irrigation System Performance') {
    //   hist_url = `${domain.Geoserver}/nhp_crop-water-demand-irrigation-total-command/wms`;
    //   hist_layer = `${this.props.hist_cropseason}`;
    // } else {
    //   hist_url = null;
    //   hist_layer = null;
    // }

    if (this.props.selectedLayer[this.props.selected]) {
      let value = this.props.selectedLayer[this.props.selected];
      console.log(value);
      let cseason =

        this.props.cropseason !== "#" ? `Season: ${this.props.cropseason}` : "";
        let season =    this.props.season !== "#" ? `Season: ${this.props.season}` : "";
      if (value.split("_")[2] === "crop" && value.split("_")[3] === "map")
        test = `<b>Crop Map <br/> Year: ${
          value.split("_")[5]
          } <br/> ${cseason} `;
      else if (
        value.split("_")[2] === "crop" &&
        value.split("_")[4] === "demand" &&
        value.split("_")[5] === "irrigation"
      )
        test = `<b>Irrigation Water Requirement (mm) <br/> Date: ${moment(
          value.split("_")[8]
        ).format("DD MMM YYYY")}</b>`;
      else if (
        value.split("_")[2] === "crop" &&
        value.split("_")[4] === "demand" &&
        value.split("_")[5] === "crop"
      )
        test = `<b>Crop Water Requirement</b> (mm) <br/> Date : ${moment(
          value.split("_")[8]
        ).format("DD MMM YYYY")}</b>`;
      else if (value.split("_")[4] === "optical")
        test = `<b>Satellite: ${capitalize('Sentinel 2')} <br/>Year: ${
          this.props.selectedOpticalYear
          } <br/> ${this.props.selectedOpticalSeason}</b>`;
      else if (value.split("_")[4] === "microwave")
        test = `<b>Satellite: ${capitalize('Sentinel 1')} <br/>Year: ${
          this.props.selectedMWYear
          } <br/> ${this.props.selectedMWSeason}</b>`;
    }
    console.log(test);
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
    // let basinoverlays,legend_bar
    if (this.props.legend_array_overlay) {
      if (isEmpty(this.props.legend_array_overlay)) {
        legend_bar = null;
      } else
        legend_bar = Object.keys(this.props.legend_array_overlay).map((key) => {
          return (
            <React.Fragment>
              <h4>{key}</h4>
              <img src={this.props.legend_array_overlay[key]} alt=""></img>
            </React.Fragment>
          );
        });
    }

    const southWest = L.latLng(16, 75),
    northEast = L.latLng(18, 78);
    const mybounds = L.latLngBounds(southWest, northEast);


    return (
      <Map
        ref={this.mapRef}
        // ref={m => { this.leafletMap = m }}
        viewport={this.props.viewport}
        onViewportChanged={this.onViewportChanged}
        // center={this.state.center}
        minZoom={this.state.minZoom}
        maxZoom={this.state.maxZoom}
        // zoom={this.state.zoom}
        onoverlayadd={this.getLegendGraphic_basic}
        onoverlayremove={this.getLegendGraphic_remove}
        //  onclick={this.props.selected? this.props.selected.split("-")[0]==='Crop Water Demand'?this.onMouseOver:null:null}
        // onlayeradd={this.onLayer}
        style={{ backgroundColor: "#fff" }}
        attributionControl={false}
        zoomControl={false}
        crs={crs}
        dragging={true}
        scrollWheelZoom={true}
        onClick={this.handleClick}
        maxBounds={mybounds}
      // onresize={this.onResizeMap}
      >
        <ZoomControl position="bottomright"/>
        {this.props.baselayerselected !== null ? (
          <WMSTileLayer
            ref={this.tileRef}
            layers={this.props.layers}
            // url='http://192.168.192.103:8080/geoserver/cite/wms'
            url={this.props.url}
            format="image/png"
            transparent={true}
            // crs={ crs}
            zIndex={1}
            onloading={this.loading}
            onload={this.load}
          />
        ) : null}

        {/* {console.log('Test 123 ca', this.props.cropArealayer)}
        {console.log('Test 123 cwsi', this.props.cwismLayer)} */}

        { (this.props.cropmap === 'ca') ? (
          <WMSTileLayer
          url={`https://bhuvan.nrsc.gov.in/nhpgs/nhp_crop-water-demand-irrigation-total-command/wms`}
          // layers={
          //   // `nhp_crop-water-demand-irrigation-total-command:nhp_crop-water-demand-irrigation-total-command_20220312`
          //   `nhp_irrigation:nhp_cm_kharif_20220910`
          // }
          layers={this.props.cropAreaLayer}
          format="image/png"
          zIndex={100}
          transparent={true}
          // opacity={1}
          // crs={ crs}
          onloading={this.loading}
          onload={this.load}
        />
        ) : (this.props.cropmap === 'cwsi') ? (
          <WMSTileLayer
          url={`https://bhuvan.nrsc.gov.in/nhpgs/nhp_crop-water-demand-irrigation-total-command-cwsim/wms`}
          layers={
            //  `nhp_irrigation:nhp_cwsim_kharif_20220910`
            this.props.cwismLayer

          }
          format="image/png"
          zIndex={100}
          transparent={true}
          // opacity={1}
          // crs={ crs}
          onloading={this.loading}
          onload={this.load}
        />
        ) : (this.props.hist_cropseason !== null) ? (
          <WMSTileLayer
            url={`${domain.Geoserver}/nhp_crop-water-demand-irrigation-total-command/wms`}
            layers={this.props.hist_cropseason.split("###")[0]}
            format="image/png"
            zIndex={100}
            transparent={true}
            // opacity={1}
            // crs={ crs}
            onloading={this.loading}
            onload={this.load}
          />

        ) : null}

        {console.log('Hist 123',  this.props.hist_cropseason)}
        {console.log('Sat 123',  this.props.selected)}

        {(this.props.selected === 'Satellite Imagery-Optical') ? (
          <WMSTileLayer
            url={`${domain.Geoserver}/nhp_satellite-imagery-optical/wms`}
            layers={this.props.selectedSatelliteLayer}
            format="image/png"
            zIndex={1000}
            transparent={true}
            // opacity={1}
            // crs={ crs}
            onloading={this.loading}
            onload={this.load}
          />

        ) : (this.props.selected === 'Satellite Imagery-Microwave') ? (
          <WMSTileLayer
            url={`${domain.Geoserver}/nhp_satellite-imagery-microwave/wms`}
            layers={this.props.selectedSatelliteLayer}
            format="image/png"
            zIndex={1000}
            transparent={true}
            // opacity={1}
            // crs={ crs}
            onloading={this.loading}
            onload={this.load}
          />

        ): null}

        {/* {this.props.selected !== null ? (
          // <Overlay name={this.props.selected.toLowerCase().split(' ').join('-') + ":" + this.props.selectedLayer[this.props.selected]} >
          <WMSTileLayer
            url={`${
              domain.Geoserver
              }/nhp_${this.props.selected
                .toLowerCase()
                .split(" ")
                .join("-")}/wms`}
            layers={
              this.props.selected.toLowerCase().split(" ").join("-") +
              ":" +
              this.props.selectedLayer[this.props.selected]
            }
            format="image/png"
            zIndex={10}
            transparent={true}
            // opacity={1}
            // crs={ crs}
            onloading={this.loading}
            onload={this.load}
          />
        ) : null} */}

        {/* { (this.props.cropmap === 'ca') || (this.props.cropmap === 'cwsi') ? (
          <WMSTileLayer
          url={`https://bhuvan.nrsc.gov.in/nhpgs/nhp_irrigation/wms`}
          layers={
            // `nhp_crop-water-demand-irrigation-total-command:nhp_crop-water-demand-irrigation-total-command_20220312`
            `nhp_irrigation:irrigation_distributary_boundaries`
          }
          format="image/png"
          zIndex={1000}
          transparent={true}
          // opacity={1}
          // crs={ crs}
          onloading={this.loading}
          onload={this.load}
        />
        ): null
        } */}

        {this.props.basinoverlays
          ? this.props.basinoverlays.map((layer, key) => (
            <WMSTileLayer
              url={`${domain.Geoserver}/nhp_irrigation/wms`}
              layers={
                layer.isChecked ? "nhp_irrigation:" + layer.layername : null
              }
              format="image/png"
              zIndex={
                layer.isChecked && this.props.arraycheck[0] === layer.value
                  ? 10000
                  : 550 + key
              }
              key={key}
              transparent={true}
              onloading={this.loading}
              onload={this.load}
            />
          ))
          : null}

        {this.props.studyarea ? (
          <GeoJSON
            ref="geojson"
            key={this.props.studyarea.features[0].id}
            data={this.props.studyarea}
            onEachFeature={this.highlightStudyArea}
            crs={crs}
            onloading={this.loading}
            onload={this.load}
          />
        ) : null}

        {(this.props.studyarea && this.props.selectedCommandArea !== 'NIS') ? (
          <WMSTileLayer
            url={`${domain.Geoserver}/nhp_irrigation_crop_mask/wms`}
            layers={
              `nhp_irrigation_crop_mask:${this.props.selectedCommandArea.toLowerCase()}_mask`
            }
            format="image/png"
            zIndex={10000}
            key={`nhp_irrigation_crop_mask:${this.props.selectedCommandArea.toLowerCase()}_mask`}
            transparent={true}
            onloading={this.loading}
            onload={this.load}
          />
        ) : null}

        {(this.props.distributary_details_visibility && this.props.basinoverlays[3].isChecked) && ((this.props.cropmap === 'ca') || (this.props.cropmap === 'cwsi')) ? (
          <GeoJSON
            ref="geojson"
            key={this.props.distributary_details.distributary}
            data={JSON.parse(this.props.distributary_details.st_asgeojson)}
            //onEachFeature={this.highlightStudyArea}
            crs={crs}
            onloading={this.loading}
            onload={this.load}
          />
        ) : null}

        {
          // this.props.stateInfo?
          //     <GeoJSON
          //         ref="geojson"
          //         key={this.props.stateInfo.key}
          //         data={this.props.stateInfo.geojson}
          //         onEachFeature={this.highlightState}
          //         crs={ crs}
          //     />
          // :null
        }
        {!isEmpty(this.props.legend_array_overlay) ? (
          <Control position="topleft">
            {/* <div className="modalwindow">
              <div
                className="modalheader"
                style={{ color: "white", textAlign: "center" }}
              >
                Swipe Layer
              </div>
              <div className="modalbox" style={{ textAlign: "center" }}>
                <input
                  id="range"
                  class="range"
                  type="range"
                  min="0"
                  max="1.0"
                  step="any"
                  value={this.state.value}
                  onChange={this.handleChange}
                  ef={this.RangeRef}
                />
              </div>
            </div> */}
          </Control>
        ) : null}

        {/* <BaseLayer name="LULC" >
                            <WMSTileLayer
                                    ref={this.tileRef}
                                    layers= 'nhp_irrigation%:LULC'
                                    // url='http://192.168.192.103:8080/geoserver/cite/wms'
                                    url={`${domain.Geoserver}/nhp_irrigation/wms`}
                                    format= 'image/png'
                                    transparent= {true}
                                    // crs={ crs}
                                    // crs={ crs}
                                    zIndex={1}
                                    onloading={this.loading}
                                    onload={this.load}
                                    
                            />
                        </BaseLayer> */}
        {/* <BaseLayer name="DEM" >
                            <WMSTileLayer
                                    ref={this.tileRef}
                                    layers= 'nhp_irrigation%:DEM'
                                    // url='http://192.168.192.103:8080/geoserver/cite/wms'
                                    url={`${domain.Geoserver}/nhp_irrigation/wms`}
                                    format= 'image/png'
                                    transparent= {true}
                                    // crs={ crs}
                                    // crs={ crs}
                                    zIndex={1}
                                    onloading={this.loading}
                                    onload={this.load}
                                    
                            />
                        </BaseLayer> */}

        {/* <Overlay name="Canal Network" >
                            <WMSTileLayer
                                    ref={this.tileRef}
                                    layers= 'nhp_irrigation%:canal_network'
                                    // url='http://192.168.192.103:8080/geoserver/cite/wms'
                                    url={`${domain.Geoserver}/nhp_irrigation/wms`}
                                    format= 'image/png'
                                    transparent= {true}
                                    // crs={ crs}
                                    zIndex={12}
                                    onloading={this.loading}
                                    onload={this.load}
                                    
                            />
                        </Overlay>
                       
                        <Overlay name="Soil Map"  >
                        <WMSTileLayer
                                    ref={this.tileRef}
                                    layers= 'nhp_irrigation%:soil_map'
                                    // url='http://192.168.192.103:8080/geoserver/cite/wms'
                                    url={`${domain.Geoserver}/nhp_irrigation/wms`}
                                    format= 'image/png'
                                    transparent= {true}
                                    // crs={ crs}
                                    zIndex={12}
                                    onloading={this.loading}
                                    onload={this.load}
                                
                                    
                            />
                    </Overlay>
                    <Overlay name="LULC" >
                            <WMSTileLayer
                                    ref={this.tileRef}
                                    layers= 'nhp_irrigation%:lulc'
                                    // url='http://192.168.192.103:8080/geoserver/cite/wms'
                                    url={`${domain.Geoserver}/nhp_irrigation/wms`}
                                    format= 'image/png'
                                    transparent= {true}
                                    // crs={ crs}
                                    // crs={ crs}
                                    zIndex={12}
                                    onloading={this.loading}
                                    onload={this.load}
                                    
                            />
                        </Overlay>
                     */}

        {/* </LayersControl> */}

        <Marker
          position={
            this.state.latlng.lat && this.state.latlng.lng
              ? [this.state.latlng.lat, this.state.latlng.lng]
              : [0, 0]
          }
        />

        <Control position="topleft">
          
          {
            (this.props.cropmap === 'ca' && this.props.cropAreaDate !== null) ? 
            ( <div style={{fontSize:'large', backgroundColor: '#b4c7e7', color: '#4472c4', padding: '5px'}}> Crop Map for {this.props.cropAreaName} as on {this.props.cropAreaDate} </div>) : 
            (this.props.cropmap === 'cwsi' && this.props.cwismDate !== null) ? 
            ( <div style={{fontSize:'large', backgroundColor: '#b4c7e7', color: '#4472c4', padding: '5px'}}> Crop Water Satisfaction for {this.props.cropAreaName} as on {this.props.cwismDate} </div>)
            : null
          }
        </Control>


        { (this.props.distributary_details_visibility && this.props.basinoverlays[3].isChecked) ? (
        <Control position="bottomright">
          
          {
            (this.props.cropmap === 'ca') ? 
            ( <div style={{textAlign: 'left', backgroundColor: colors.final_side_inner, color: 'black', padding: '3px', border: '1px solid black'}}>
                  <div
                    class="closebox"
                    onClick={this.handleDialogClose}
                  ></div>
                  <div>
                    <h5>Distributary Details</h5>
                    Name of the Distributary: <b> {this.props.distributary_details.distributary} </b>
                    <br/>
                    Time Period: <b> {this.props.distributary_details.date} </b>
                    <br/>
                    Crop Area (ha):
                    <br/> &nbsp;&nbsp;&nbsp;
                    Paddy: <b> {this.props.distributary_details.paddy} </b>
                    <br/> &nbsp;&nbsp;&nbsp;
                    Irrigated Dry: <b> {this.props.distributary_details.id} </b>
                    <br/> &nbsp;&nbsp;&nbsp;
                    Biseasonal: <b> {this.props.distributary_details.bi} </b>
                    <br/> &nbsp;&nbsp;&nbsp;
                    Perinnial: <b> {this.props.distributary_details.perinnial} </b>
                    <br/>
                    Rainfall Expected (mm): <b> {this.props.distributary_details.rain} </b>
                    <br/>
                    Estimated Irrigation Requirement (MCM): <b> {this.props.distributary_details.gir} </b>

                  </div>

              </div>) : 
              (this.props.cropmap === 'cwsi') ?
            ( <div style={{textAlign: 'left', backgroundColor: colors.final_side_inner, color: 'black', padding: '3px', border: '1px solid black'}}>
                <div
                    class="closebox"
                    onClick={this.handleDialogClose}
                  ></div>
                  <div>
                    <h5>Distributary Details</h5> 
                    Name of the Distributary: <b> {this.props.distributary_details.distributary} </b>
                    <br/>
                    Time Period: <b> {this.props.distributary_details.date} </b>
                    <br/>
                    Crop Water Satisfaction Index: <b> {this.props.distributary_details.cwsi} </b>
                  </div>
              </div>)
              : null
          }

        </Control>) : null}

        <Control position="topleft">
          <Popup
            trigger={
              <Button
                size="tiny"
                onClick={this.resetZoom}
                compact
                style={{ padding: "8px" }}
              >
                <FontAwesomeIcon icon="globe-asia" size="lg" />
              </Button>
            }
            position="right center"
          >
            <Popup.Content>Reset Zoom</Popup.Content>
          </Popup>
        </Control>

        {this.state.layerloading ? (
          <Control position="topleft">
            <div style={style}>
              <FadeLoader
                height="15"
                radius="3"
                margin="3"
                width="10"
                // css={override}
                sizeUnit={"px"}
                // size={150}
                color={"#123abc"}
                loading={this.state.layerloading}
              />
            </div>
          </Control>
        ) : null}
        
        {/* <Control position="topleft">
          <div>
            {this.state.showInfo ? (
              <div
                style={{
                  marginRight: "0px",
                  paddingLeft: "0rem",
                  paddingRight: "0rem",
                  marginLeft: "0px"
                }}
              >
                <Button
                  basic
                  attached="right"
                  floated="right"
                  size="tiny"
                  compact
                  style={{ padding: "5px" }}
                  onClick={this.showInfo}
                  color={isNull(this.props.pointInfo) ? "brown" : "teal"}
                >
                  <FontAwesomeIcon icon="window-close" size="lg" />
                </Button>
                <Message
                  icon="map marker alternate"
                  info
                  warning={isNull(this.props.pointInfo)}
                  attached="bottom"
                >
                  <Icon name="map marker alternate" />
                  {this.props.pointInfo !== null ? (
                    <Message.Content>
                      <Message.Header>{this.props.selected}</Message.Header>
                      <b>Date:</b>&nbsp;{this.props.activeDate}
                      <br />
                      {isNull(this.props.pointInfo) ? (
                        <div>
                          <b>Data not available in this region</b>
                        </div>
                      ) : (
                        <div>
                          <b>Value:</b>&nbsp;{this.props.pointInfo}{" "}
                        </div>
                      )}
                      <b></b>
                      
                    </Message.Content>
                  ) : (
                    "Select a place within Indian boundary"
                  )}
                </Message>
              </div>
            ) : (
              <Popup
                trigger={
                  <Button
                    size="tiny"
                    compact
                    style={{ padding: "8px" }}
                    onClick={this.showInfo}
                  >
                    <FontAwesomeIcon icon="info-circle" size="lg" />
                  </Button>
                }
                position="right center"
              >
                <Popup.Content>
                  click this to know about what is in the point you clicked in
                  the map
                </Popup.Content>
              </Popup>
            )}
          </div>
        </Control> */}

     {window.innerWidth > 1000 ?
          <Control position="topleft">
            <Button
              onClick={this.props.handleAnimationChange}
              secondary
              style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
              attached="right"
              compact
              size="mini"
            >
              <FontAwesomeIcon icon="th-list" size="sm" />
            </Button>
          </Control>
           : <Control position="bottomleft">
            <Button
              onClick={this.props.handleAnimationChange}
              secondary
              style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
              attached="right"
              compact
              size="mini"
            >
              <FontAwesomeIcon icon="th-list" size="sm" />
            </Button>
          </Control>}

        {/* {
                        this.props.selected?
                        !this.props.visibleGraphPanel &&  this.props.selected.split("-")[0]==='Crop Water Demand'  ?
                            <Control position='bottomright'>
                                <Popup
                                    trigger={
                                        <Button onClick={this.props.toggleVisibleGraphPanel} secondary style={{backgroundColor:colors.sidebar}} compact size="medium">
                                            <FontAwesomeIcon icon="chart-bar" size="lg"/>
                                        </Button>
                                    }
                                    position='left center'
                                >
                                    <Popup.Content>Shows Graphical Analysis</Popup.Content>
                                </Popup>
                                
                            </Control>
                        :null:null
                    }
                */}

                {
                  ((this.props.selected === 'Historical Season-Crop Map Historic') || (this.props.selected === 'Historical Season-Irrigation Requirement') || (this.props.selected === 'Historical Season-Irrigation System Performance')) ? (
                    <Control position='bottomright'>
                        <Popup
                            trigger={
                                <Button onClick={this.props.toggleVisibleGraphPanel} secondary style={{backgroundColor:colors.sidebar}} compact size="medium">
                                    <FontAwesomeIcon icon="chart-bar" size="lg"/>
                                </Button>
                            }
                            position='left center'
                        >
                            <Popup.Content>Command Area Details</Popup.Content>
                        </Popup>
                        
                    </Control>
                  ) : null
                }


                {/* // Layer Selection ... */}

        <Control position="topright">
          
          <OffCanvas
            width={200}
            transitionDuration={300}
            effect={"overlay"}
            style={{ paddingTop: "50px", cursor: "move" }}
            isMenuOpened={this.state.isMenuOpened}
            position={"right"}
          >
            <div style={{ width: '160px', paddingTop: "50px" }}>
            <OffCanvasMenu
              style={{
                alignContent: "center",
                paddingTop: "50px",
                display: "contents",
                backgroundColor: "rgb(255,255,255)",
                borderColor: "blue",
                top: "50px",
                marginRight: "10px",
                width: '100%'
              }}
              id="box"
            >
              
              <div style={{ width: 'inherit', background: colors["final_side"] }}>
                <Menu.Item
                  as="div"
                  onClick={this.displayBaseLayers}
                  style={{ textAlign: "center", marginLeft: `5px` }}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        width: "80%",
                        color: colors.textcolor,
                        fontSize: "small",
                        cursor: "default",
                      }}
                    >
                      Base Layers
                    </div>
                    <div
                      style={{
                        textAlign: "right",
                        width: "20%",
                        marginRight: "10px",
                      }}
                    >
                      {this.state.baseLayers ? (
                        <FontAwesomeIcon icon="angle-down" />
                      ) : (
                          <FontAwesomeIcon icon="angle-right" />
                        )}
                    </div>
                  </div>
                </Menu.Item>
              </div>
              {this.state.baseLayers ? (
                <div style={{  backgroundColor: "rgb(255,255,255)", paddingLeft:"21%",textAlign:"initial",}}>
                  <table>
                  <tr><input
                    type="radio"
                    name="baselayer"
                    value="Satellite"
                    checked={this.props.baselayerselected === "Satellite"}
                    onChange={this.changeBaseLayer}
                  />{" "}
                  Satellite</tr>
                  <tr style={{ backgroundColor:"none",}}><input 
                    type="radio"
                    name="baselayer"
                    value="Map"
                    checked={this.props.baselayerselected === "Map"}
                    onChange={this.changeBaseLayer}
                  />{" "}
                  Map</tr>
                  <tr><input
                    type="radio"
                    name="baselayer"
                    value="Command Area"
                    checked={this.props.baselayerselected === "Command Area"}
                    onChange={this.changeBaseLayer}
                  />{" "}
                  Command Area
                  </tr>
                  </table>
                </div>
              ) : null}

              <div style={{ background: colors["final_side"] }}>
                <Menu.Item
                  as="div"
                  onClick={this.displayLegend}
                  style={{ textAlign: "center", marginLeft: `5px` }}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        width: "80%",
                        color: colors.textcolor,
                        fontSize: "small",
                        cursor: "default",
                      }}
                    >
                      Legend
                    </div>
                    <div
                      style={{
                        textAlign: "right",
                        width: "20%",
                        marginRight: "10px",
                      }}
                    >
                      {this.state.legendVisible ? (
                        <FontAwesomeIcon icon="angle-down" />
                      ) : (
                          <FontAwesomeIcon icon="angle-right" />
                        )}
                    </div>
                  </div>
                </Menu.Item>
              </div>
              
              {this.state.legendVisible ? (
                <center style={{backgroundColor:colors.final_side_inner}}>
                  {test !== undefined ? (
                    <p
                      style={{
                        textAlign: "center",
                        fontWeight: "600",
                        fontSize: "12px",
                      }}
                    >
                      {" "}
                      {ReactHTMLParser(test)}
                    </p>
                  ) : null}

                  { (this.props.selected === 'Current Season-Command Area') ? (

                    <div>
                      {(this.props.cropmap === 'ca') ? 
                      <p>
                        <b>Crop Map</b>
                        <br/><img src={this.getLegendGraphicIrrigation('nhp_irrigation','nhp_crop')} alt="" /><br/>

                      </p> : (this.props.cropmap === 'cwsi') ? 
                      <p>
                        <b>Crop Water Satisfaction</b>
                        <br/><img src={this.getLegendGraphicIrrigation('nhp_irrigation','nhp_cwsi')} alt="" /><br/>

                      </p> : null}
                      
                      
                    </div>

                    ) : (this.props.selected === 'Historical Season-Crop Map Historic') ? (
                      <div>
                        <b>Historic Season - Crop Map</b>
                        <br/><img src={this.getLegendGraphicIrrigation('nhp_irrigation','nhp_crop')} alt="" /><br/>
                        

                      </div>

                    ) : (this.props.selected === 'Historical Season-Irrigation Requirement') ? (
                      <div>
                        <b>Historic Season - Crop Map</b>
                        <br/><img src={this.getLegendGraphicIrrigation('nhp_irrigation','nhp_crop')} alt="" /><br/>

                      </div>

                    ) : (this.props.selected === 'Historical Season-Irrigation System Performance') ? (
                      <div>
                        <b>Historic Season - Irrigation System Performance</b>
                        <br/><img src={this.getLegendGraphicIrrigation('nhp_irrigation','nhp_cwsi')} alt="" /><br/>

                      </div>

                    ) : null
                  }

                  {this.props.basinoverlays
                    ? this.props.basinoverlays.map((layer, key) => (

                      (layer.isChecked) ? (
                        <div>
                          <b>{layer.value}</b>
                          <br/><img src={this.getLegendGraphicOverlay('nhp_irrigation', layer.layername)} alt="" /><br/>

                        </div>) : null

                      

                    ))
                  : null}

                  {/* {this.props.selected === "Crop Water Demand-Irrigation Water Requirement"?<img src={this.props.legend} alt="" />:
                   this.props.selected === "Crop Water Demand-Crop Water Requirement"?<img src={this.props.legend} alt="" />:


                    <div className="info legend">
                      {this.props.season !== "#" ? this.props.legend : null}
                    </div>
                  } */}
                   
                   
                  
                 
                  {/* {window.innerHeight>1000?legend_bar:null} */}
                </center>
              ) : null}

            

            </OffCanvasMenu>
            </div>
          </OffCanvas>
          
        </Control>

        {/* <Control position= 'bottomleft' style={{pointerEvents:"auto", cursor:"auto"}}>
                        
                        {/* <DateSlider {...this.props.sliderOptions}/> */}
        {/* </Control> */}
        <MouseControl position="bottomleft" />
        <ScaleControl metric={true} />
        {this.props.selected ? (
          this.props.selected.split("-")[0] === "Crop Water Demand" ? (
            <Control
              position="bottomleft"
              style={{ pointerEvents: "auto", cursor: "auto" }}
            >
              <DateSlider {...this.props.sliderOptions} />
            </Control>
          ) : null
        ) : null}
        {/* <Dialog ref={(ref) => { this.dialog = ref; }} id="dialog1" initOpen={false} minSize={[ 100, 100 ]} size={[350,350]} maxSize={[ 600, 600 ]} anchor={[15, 50]}>
                        <div></div>
                    </Dialog> */}
      </Map>
      //(this.state.latlng.lat && this.state.latlng.lng)?<div style={{height: "10%", width: "100%"}}>{this.state.latlng.lat}, {this.state.latlng.lng}</div>:null} }
    );
  }
}

export default MapView;
